import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Install from "@/pages/Install";
import MemberDashboard from "@/pages/member/MemberDashboard";
import OwnerRoot from "@/pages/owner/OwnerRoot";
import ManagerDashboard from "@/pages/manager/ManagerDashboard";
import KasirPOS from "@/pages/kasir/KasirPOS";
import KDS from "@/pages/dapur/KDS";
import CustomerDisplay from "@/pages/CustomerDisplay";
import FinanceDashboard from "@/pages/owner/FinanceDashboard";
import { Brand } from "@/components/Brand";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-hotpot-grid">
      <div className="animate-pulse"><Brand size={72} /></div>
    </div>
  );
}

function RoleHome() {
  const { user } = useAuth();
  switch (user.role) {
    case "member": return <MemberDashboard />;
    case "owner": return <OwnerRoot />;
    case "manager": return <ManagerDashboard />;
    case "kasir": return <KasirPOS />;
    case "dapur": return <KDS />;
    case "keuangan": return <FinanceDashboard />;
    default: return <div className="p-10 text-white">Role tidak dikenal.</div>;
  }
}

function Gate() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  return (
    <Routes>
      <Route path="/customer-display" element={<CustomerDisplay />} />
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/install" element={<Install />} />
      <Route path="/*" element={user ? <RoleHome /> : <Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Gate />
          <Toaster position="top-center" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
